import React from 'react';
import { ArcherContainer, ArcherElement } from 'react-archer';
import SpeakIt from './CompAISpeakIt'; // Assuming CompAISpeakIt is in the same directory

export default function CompAIStoryBoardCompanyBackground({ businessModelData }) {
    if (!businessModelData) {
        return null; // Or some loading/placeholder state
    }

    return (
        <ArcherContainer strokeColor="rgba(255,255,255,0.3)"
            lineStyle="curve"
            startMarker={false} endMarker={true}>
            <div className=" mb-12 mt-12  rounded-lg px-6 animate__animated animate__fadeIn">
                <div className="mb-8 flex flex-col md:flex-row gap-0">
                    {/* Left column - Summary */}
                    <div className="w-7/12  ">
                        <h3 className="text-4xl text-zinc-50 mb-4 sp-big-heading">Company Story</h3>
                        <h3 className="text-2xl text-zinc-50 mb-4">{businessModelData.headline}</h3>
                        <div className="mb-6">
                            <p className="text-zinc-200 leading-7 text-base mb-4">{businessModelData.story.opening}</p>
                            <ArcherElement
                                id="revenue-streams"
                                relations={[{
                                    targetId: 'revenue-detail',
                                    targetAnchor: 'left',
                                    sourceAnchor: 'right',
                                    style: { strokeColor: '#437660', strokeWidth: 2, strokeDasharray: '2,5', }
                                }]}
                            >
                                <div>
                                    <div className="text-zinc-100 my-4 text-base leading-8 border-emerald-400/50 bg-black/20 rounded-l-lg border-r-2 p-4 -ml-4">
                                        <div className="text-base font-medium text-emerald-200 mb-2">
                                            How they Make Money
                                        </div>
                                        {businessModelData.story.revenueStreams}
                                    </div>
                                </div>
                            </ArcherElement>

                            <ArcherElement
                                id="products-services"
                                relations={[{
                                    targetId: 'products-services-detail',
                                    targetAnchor: 'left',
                                    sourceAnchor: 'right',
                                    startMarker: false,
                                    endMarker: false,
                                    style: {
                                        strokeColor: '#6A528C', strokeWidth: 2, strokeDasharray: '2,5', markerEnd: 'none',
                                        markerStart: 'none'
                                    }
                                }]}
                                className="print:hidden"
                            >
                                <div>
                                    <div className="text-zinc-100 my-4 text-base leading-8 border-purple-400/50 bg-black/20 rounded-l-lg border-r-2 p-4 -ml-4">
                                        <div className="text-base font-medium text-purple-200 mb-2">
                                            What they Sell
                                        </div>
                                        {businessModelData.story.productsAndServices}
                                    </div>
                                </div>
                            </ArcherElement>

                            <ArcherElement
                                id="key-customers"
                                relations={[{
                                    targetId: 'key-customers-detail',
                                    targetAnchor: 'left',
                                    sourceAnchor: 'right',
                                    style: { strokeColor: '#46608B', strokeWidth: 2, strokeDasharray: '2,5', }
                                }]}
                                className="print:hidden"
                            >
                                <div className="text-zinc-100 my-4 text-base leading-8 border-blue-400/50 bg-black/20 rounded-l-lg border-r-2 p-4 -ml-4">
                                    <div className="text-base font-medium text-blue-200 mb-2">
                                        Who they Serve
                                    </div>
                                    {businessModelData.story.keyCustomers}
                                </div>
                            </ArcherElement>

                            <ArcherElement
                                id="key-competitors"
                                relations={[{
                                    targetId: 'key-competitors-detail',
                                    targetAnchor: 'left',
                                    sourceAnchor: 'right',
                                    style: { strokeColor: '#855A39', strokeWidth: 2, strokeDasharray: '2,5', }
                                }]}
                                className="print:hidden"
                            >
                                <div className="text-zinc-100 my-4 text-base leading-8 border-orange-300/50 bg-black/20 rounded-l-lg border-r-2 p-4 -ml-4">
                                    <div className="text-base font-medium text-orange-200 mb-2">
                                        Competition
                                    </div>
                                    {businessModelData.story.keyCompetitors}
                                </div>
                            </ArcherElement>

                            <ArcherElement
                                id="financial-analysis"
                                relations={[{
                                    targetId: 'financial-analysis-detail',
                                    targetAnchor: 'left',
                                    sourceAnchor: 'right',
                                    style: { strokeColor: '#437660', strokeWidth: 2, strokeDasharray: '2,5', }
                                }]}
                                className="print:hidden"
                            >
                                <div className="text-zinc-100 my-4 text-base leading-8 border-emerald-400/50 bg-black/20 rounded-l-lg border-r-2 p-4 -ml-4">
                                    <div className="text-base font-medium text-emerald-200 mb-2">
                                        Financial Analysis
                                    </div>
                                    {businessModelData.story.financialAnalysis}
                                </div>
                            </ArcherElement>
                            <p className="text-zinc-200 leading-7 text-base mb-4">{businessModelData.story.bigTakeaway}</p>
                        </div>
                    </div>

                    <div className="w-5/12  pl-24  py-6 ">
                        <SpeakIt textToSpeak={businessModelData.story.opening + businessModelData.story.productsAndServices + businessModelData.story.revenueStreams + businessModelData.story.keyCustomers + businessModelData.story.keyCompetitors + businessModelData.story.financialAnalysis + businessModelData.story.bigTakeaway}
                            title={businessModelData.headline} />
                        <ArcherElement id="revenue-detail">
                            <div className="bg-emerald-900/10 rounded-lg p-4 mb-6 flex flex-col">
                                <div className="text-emerald-400   text-xl font-medium mb-2">
                                    <div className="flex items-center gap-4">
                                        <div className="rounded  h-16 flex items-center justify-center">
                                            <div className="rounded w-12 h-12 flex items-center justify-center bg-emerald-900/30">
                                                <img src="/util/app/b3-admin-revenue.svg" className="h-full w-full p-2" alt="Revenue Streams"/>
                                            </div>
                                        </div>
                                        <h4 className="text-emerald-200 font-base">
                                            Revenue Streams
                                        </h4>
                                    </div>
                                </div>
                                <ul className="list-disc pl-8 space-y-2 flex-grow">
                                    {businessModelData.revenueStreams.map((stream, i) => (
                                        <li key={i} className="text-zinc-200 text-sm leading-4 pl-2 marker:text-emerald-500 print:text-sm">{stream}</li>
                                    ))}
                                </ul>
                            </div>
                        </ArcherElement>
                        <ArcherElement id="products-services-detail">
                            <div className="bg-purple-900/10 rounded-lg p-4 mb-6 flex flex-col">
                                <div className="text-purple-400  text-xl font-medium mb-2">
                                    <div className="flex items-center gap-4">
                                        <div className="rounded bg-purple-900/30  w-12 h-12 flex items-center justify-center">
                                            <img src="/util/app/b3-admin-products-services.svg" className="h-full w-full p-2" alt="Products and Services" />
                                        </div>
                                        <h4 className="text-purple-200 font-base">
                                            Products & Services
                                        </h4>
                                    </div>
                                </div>
                                <ul className="list-disc pl-8 space-y-2 flex-grow">
                                    {businessModelData.productsAndServices.map((item, i) => (
                                        <li key={i} className="text-zinc-200 text-sm leading-4 pl-2 marker:text-purple-500 print:text-sm">{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </ArcherElement>
                        <ArcherElement id="key-customers-detail">
                            <div className="bg-blue-900/10 rounded-lg p-4 mb-6 flex flex-col">
                                <div className="text-blue-400 py-1.5 text-xl font-medium mb-2">
                                    <div className="flex items-center gap-4">
                                        <div className="rounded bg-blue-900/30  w-12 h-12 flex items-center justify-center">
                                            <img src="/util/app/b3-admin-customer.svg" className="h-12 p-2" alt="Key Customers"/>
                                        </div>
                                        <h4 className="text-blue-200 font-base">
                                            Key Customers
                                        </h4>
                                    </div>
                                </div>
                                <ul className="list-disc pl-8 space-y-2 flex-grow">
                                    {businessModelData.keyCustomers.map((customer, i) => (
                                        <li key={i} className="text-zinc-200 text-sm leading-4 pl-2 marker:text-blue-500 print:text-sm">{customer}</li>
                                    ))}
                                </ul>
                            </div>
                        </ArcherElement>
                        <ArcherElement id="key-competitors-detail">
                            <div className="bg-orange-900/10 rounded-lg p-4 mb-6 flex flex-col">
                                <div className="text-xl    font-medium      mb-3 flex    items-center ">
                                    <div className="rounded bg-orange-900/30  w-12 h-12 flex items-center   justify-center">
                                        <img src="/util/app/b3-admin-competition-2.svg" className="h-full w-full p-1.5  " alt="Key Competitors" />
                                    </div>
                                    <h4 className="ml-4 text-orange-200    font-base">
                                        Key Competitors
                                    </h4>
                                </div>
                                <div className="flex mt-2 flex-wrap gap-3">
                                    {businessModelData.competitors.map((competitor, i) => (
                                        <span
                                            key={i}
                                            className={`px-3 py-1 rounded-full text-sm ${competitor.comparison === 'same' ? 'bg-black/30 text-orange-200' :
                                                competitor.comparison === 'worse' ? 'bg-black/30 text-red-200' :
                                                    'bg-black/30 text-green-200'
                                                }`}
                                        >
                                            {competitor.name}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </ArcherElement>
                        <ArcherElement id="financial-analysis-detail">
                            <div className="mb-8 bg-emerald-900/10 p-4 rounded-lg">
                                <div className="text-xl text-emerald-200 mb-3 flex items-center">
                                    <div className="rounded bg-emerald-900/30  w-12 h-12 flex items-center   justify-center">
                                        <img src="/util/app/b3-admin-financial-analysis.svg" className="h-full w-full p-2" alt="Financial Analysis"/>
                                    </div>
                                    <h4 className="ml-4 text-emerald-200 font-semibold">
                                        Financial Analysis
                                    </h4>
                                </div>
                                <div className=" gap-4">
                                    <div className="">
                                        <h5 className="text-emerald-200 text-base mt-2">Revenue & Growth</h5>
                                        <p className="text-zinc-200 text-sm leading-6">{businessModelData.financialAnalysis.revenueAndGrowth}</p>
                                    </div>
                                    <div className="">
                                        <h5 className="text-emerald-200 text-base mt-2">Key Financial Challenges</h5>
                                        <p className="text-zinc-200 text-sm leading-6">{businessModelData.financialAnalysis.keyFinancialChallenges}</p>
                                    </div>
                                </div>
                            </div>
                        </ArcherElement>
                    </div>
                </div>
            </div>
        </ArcherContainer>
    );
} 